import { Form, Row, Col } from 'react-bootstrap'

function UpdatesSettings() {
    return (
        <div className="updatesSettings py-5">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <p><strong>Updates</strong></p>
                    <p className="mb-2">You can control the topics you’d like to get updated about.<br/>
                        This allows you to have one primary interest but get updates on multiple topics.</p>
                    <p>Your current primary interest is:</p>
                    <Form>
                        <Form.Group controlId="UpdateWellness">
                            <Form.Check type="checkbox" className="custom-control custom-checkbox pt-1">
                                <Form.Check.Input type="checkbox" className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label">Wellness and Nutrition</Form.Check.Label>
                            </Form.Check>
                        </Form.Group>
                        <Form.Group controlId="UpdateBusiness">
                            <Form.Check type="checkbox" className="custom-control custom-checkbox pt-1">
                                <Form.Check.Input type="checkbox" className="custom-control-input" />
                                <Form.Check.Label className="custom-control-label">Business and Lifestyle</Form.Check.Label>
                            </Form.Check>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default UpdatesSettings

